if (!customElements.get('plan-selector')) {
  customElements.define(
    'plan-selector',
    class PlanSelector extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        // Sync the CTA label (and hidden form fields) to whichever plan is
        // checked on render, so it reads "Continue with X Plan" immediately —
        // not just after the shopper switches plans at least once.
        const checked = this.getActiveInput();
        if (checked) this.syncFromInput(checked, { announce: false });
      }

      // Tier mode (snippets/tier-plan-selector.liquid) has one checked
      // frequency per tier panel; only the open tier's one is active.
      getActiveInput() {
        const tierInput = this.querySelector('.tier-plan__tier-input:checked');
        const scope = tierInput ? tierInput.closest('.tier-plan__tier') : this;
        return scope.querySelector('.plan-selector__input:checked');
      }

      onChange(event) {
        const input = event.target;
        if (!input) return;
        if (input.classList.contains('tier-plan__tier-input')) {
          this.onTierChange(input);
          return;
        }
        if (!input.classList.contains('plan-selector__input')) return;
        this.syncFromInput(input, { announce: true });
      }

      // Keep the shopper's frequency when the new tier offers it, otherwise
      // fall back to that tier's recommended (12 week) plan.
      onTierChange(tierInput) {
        const options = Array.from(
          tierInput.closest('.tier-plan__tier').querySelectorAll('.plan-selector__input:not(:disabled)'),
        );
        const next =
          options.find((option) => option.dataset.weeks === this.activeWeeks) ||
          options.find((option) => 'recommended' in option.dataset) ||
          options[0];
        if (!next) return;
        next.checked = true;
        this.syncFromInput(next, { announce: true });
      }

      syncFromInput(input, { announce }) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;

        if (input.dataset.weeks) this.activeWeeks = input.dataset.weeks;
        this.updateVariantInput(productForm, input);
        this.updateSellingPlan(productForm, input);
        this.updateAddButton(productForm, input);
        this.updateUrl(input);
        if (announce) this.announce(input);
      }

      updateVariantInput(productForm, input) {
        const idInput = productForm.querySelector('input[name="id"]');
        if (!idInput || !input.dataset.variantId) return;
        idInput.value = input.dataset.variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateSellingPlan(productForm, input) {
        const managedInput = productForm.querySelector('input[name="selling_plan"][data-managed-selling-plan]');
        if (!managedInput) return;
        managedInput.value = input.dataset.sellingPlanId || '';

        productForm.querySelectorAll('input[name="selling_plan"]:not([data-managed-selling-plan])').forEach((el) => {
          el.disabled = true;
        });
      }

      updateAddButton(productForm, input) {
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonLabel = productForm.querySelector('[name="add"] [data-button-text]');
        if (!addButton) return;

        if (input.disabled) {
          addButton.setAttribute('disabled', 'disabled');
          if (addButtonLabel && window.variantStrings) {
            addButtonLabel.textContent = window.variantStrings.soldOut;
          }
          return;
        }

        addButton.removeAttribute('disabled');
        if (addButtonLabel && input.dataset.ctaLabel) {
          addButtonLabel.textContent = input.dataset.ctaLabel;
        }
      }

      updateUrl(input) {
        if (!this.dataset.url || !input.dataset.variantId) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${input.dataset.variantId}`);
      }

      announce(input) {
        const region = this.querySelector('[data-plan-selector-announce]');
        if (!region) return;
        region.textContent = input.dataset.announce || '';
      }
    },
  );
}
